import {createSlice} from "@reduxjs/toolkit";

const slice = createSlice({
    name: "ProductCompare",
    initialState: {
        data: {
            //Example of data which will be loaded run time
            //99922094: {ItemNumber: '99922094'}
        },
        products: {},
        products_inventory: {},
        products_pricing: {},
    },
    reducers: {
        loadData: {
            reducer: (state, action) => {
                state.data = action.payload.data;
                state.products = action.payload.products;
                state.products_inventory = action.payload.products_inventory;
                state.products_pricing = action.payload.products_pricing;
                return state;
            },
        },
        DataAssets: {
            reducer: (state, action) => {
                state.products = action.payload.products;
                state.products_inventory = action.payload.products_inventory;
                state.products_pricing = action.payload.products_pricing;
                return state;
            },
        },
        removeAll: {
            reducer: (state, action) => {
                state.data = {};
                state.products = {};
                state.products_inventory = {};
                state.products_pricing = {};
                return state;
            },
        },
    }
});

export let {loadData, removeAll, DataAssets} = slice.actions;

export default slice.reducer;
